import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryBase from "../components/EntryBase";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata,
    getformid, getcontroller, getsubkey, initializedata, isEnabled
} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const BrandMst = props => {

    const panelsdef = [];
    const G_id = { BASE: "0" };
    const formid = getformid("BrandMst", props.location.search);
    const controller = getcontroller("BrandMst", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formListOption = useSelector(state => state.form.listoption);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const baseref = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);
    const editingTypeRef = useRef("0");

    const formstatus = useSelector(state => state.form.status);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [primarykeys, setprimarykeys] = useState([]);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    const entrydataRef = useRef(null);

    function SetGridData(panelInfo, data) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panelInfo) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panelInfo, coldef) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panelInfo, api) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panelInfo) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panelInfo, api) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panelInfo) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    const actionurl = {
        "insert": "Forms/Insert",
        "update": "Forms/Update",
        "delete": "Forms/Delete",
        "getlist": "BrandMst/GetListData",
    };

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }

    function currentLayoutType() {
        if (!isEmpty(editingTypeRef.current)) return editingTypeRef.current;
        if (!isEmpty(baseref.current)) return baseref.current.ListType();
        return "0";
    }

    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(formListOption) || formListOption.length === 0) return target;

        let newdata = { ...target };
        formListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
            }
        });

        return newdata;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;

        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    setprimarykeys(data.primarykeys ?? []);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panelInfo) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panelInfo.id, type: panelInfo.type, index: idx });
                        idx++;

                        let totalColumn = data.colinfo.find(e => e.logpid === "T" + panelInfo.id);
                        if (!isEmpty(totalColumn)) {
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panelInfo.id, type: totalColumn.type, index: idx });
                            idx++;
                        }
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {
                        RestoreLayout(data.panels, fields);
                    }

                    let state = props.location.state;
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state) && "code" in state) {
                        clearform();
                        dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search, corpkey, account, controller, subkey, dispatch]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1);
    }, [menuinfo]);

    useEffect(() => {
        if (formstatus !== "COPY FORM" || isEmpty(columninfo)) return;
        columninfo.filter(e => e.copyclear).forEach(function (col) {
            entrydataRef.current[col.columnid] = "";
        });
        rerender();
    }, [formstatus, columninfo]);

    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else if (!isEmpty(locationstate.current.acceptno)) {
            clearform();
        }
        locationstate.current = null;
    }
    function onFirstDataRendered(param, panelInfo) {
        SetGridApi(panelInfo, param.api);
        SetGridColApi(panelInfo, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false;
                    break;
                }
            }
            if (call) callshow();
        }
    }
    function Show(data, pushcode) {
        let code = "";
        editingTypeRef.current = !isEmpty(baseref.current) ? baseref.current.ListType() : "0";

        if (data === undefined) {
            if (!isEmpty(pushcode)) {
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]];
                        break;
                    }
                }
            }
            setedittingcode(code);
        }

        if (isEmpty(columninfo)) return false;

        clearform(code === "");
        LoadData(code);
        return true;
    }

    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let target = newpanel.find(e => e.id === id && e.type === type);
        if (isEmpty(target)) return;
        target.hide = !show;
        setpanel(newpanel);
    }
    function storeRowData(panelInfo) {
        if (panelInfo === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panelInfo, AGRef.current.GetDatasource(GridApi(panelInfo)));
        }
    }

    function Jump(id, type) {
        let panelid = "basepanel" + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        EntrybodyRef.current.scrollTop = elem.offsetTop - 50;
    }

    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();
        if (action === "save") Save(finallycallback);
        if (action === "delete") Delete(finallycallback);
        if (action === "clear") {
            clearform(true);
            return;
        }
        if (action === "linkfield") {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid === G_id.BASE) {
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            Jump(col.logpid, col.type);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: col.logpid, type: col.type }));
        }
    }
    function LoadData(code) {
        if (code === "") return;

        fnc.current.postaxios('BrandMst/GetData', { "code": code, "type": currentLayoutType(), "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        const beforeData = entrydataRef.current;

                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = keepListOptionValue(data.data, beforeData);

                        for (let i = 0; i < gridlist.length; i++) {
                            const detailRows = data.detail[gridlist[i].type];
                            if (Array.isArray(detailRows) ? detailRows.length !== 0 : !isEmpty(detailRows)) {
                                SetGridData({ id: gridlist[i].id, type: gridlist[i].type }, detailRows);
                            }
                        }

                        rerender();
                        dispatch(changestatus("ENTRY FORM"));
                        fnc.current.wait(false);
                    } catch (error) {
                        fnc.current.warnmsg("入力フォームデータの表示に失敗しました。");
                        dispatch(changestatus("VIEW"));
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "表示に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function clearform(newform) {
        const beforeData = entrydataRef.current;

        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        fnc.current.modify(false);

        if (isEnabled(newform)) {
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
                        rerender();
                    },
                }, true
            )
        }
    }

    function ValueChanged(id) {
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col) && col.extriggerref) {
            dispatch(entrytriggercall(id));
        }
    }

    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    function RestoreLayout(panels, fields) {
        RestorePanel(panels);
        RestoreBase(fields)
    }
    function RestorePanel(panelData) {
        let savedPanel = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(savedPanel)) return;
        if (panelData.length !== savedPanel.length) return;
        for (let i = 0; i < savedPanel.length; i++) {
            let item = panelData.find(e => e.id === savedPanel[i].id && e.type === savedPanel[i].type);
            if (isEmpty(item)) return;
            savedPanel[i].name = item.name;
            savedPanel[i].name2 = item.name2;
            savedPanel[i].abbr = item.abbr;
        }
        setpanel(savedPanel);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    function LayoutSaveStorage() {
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id, gridlist[i].type) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id, type: panel[p].type }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id, panel[p].type);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function () {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout) {
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    }
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function tabletype(id, type) {
        if (!isEmpty(type)) return type;
        if (id.substr(0, 1) === "T") {
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        }
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.grid) {
            return (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    ValueChanged={() => storeRowData(props.panel)}
                    RemoveRow={() => storeRowData(props.panel)}
                    formid={formid}
                    panel={props.panel}
                />
            );
        }
        return null;
    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true;
            if (!isEmpty(type) && !panel.some(e => e.id === id && e.type === type)) return true;
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id, type);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            key={p.id + "_" + p.type + "_" + i}
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== G_id.BASE || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="レイアウト設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    function Save(finallycallback, nocheck) {
        storeRowData();
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            detail[gridlist[i].type] = GridData(gridlist[i]);
        }
        const paramdata = {
            "controller": formid,
            "layout_type": currentLayoutType(),
            "data": entrydataRef.current,
            "detail": detail,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "BrandMst/UpdateEntry" : "BrandMst/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if (pkey !== "") entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }

                        fnc.current.success();
                        if (formstatus === "ENTRY FORM") {
                            data.data['rowid'] = Getrowid();
                            finallycallback(data.data);
                        }
                        LoadData(code);
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            var msgs = ["警告を確認してそのまま保存する場合はOK、修正する場合はCancelを選択してください", ""];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の入力内容により保存できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "保存に失敗しました"
            }
        )
    }

    function Delete(finallycallback) {
        const layoutType = currentLayoutType();
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller,
            tabletype: layoutType,
            type: layoutType,
            colinfo: columninfo
        }
        fnc.current.postaxios("Forms/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }

    function primarykey() {
        if (isEmpty(primarykeys) || primarykeys.length === 0) return "";
        return primarykeys[0];
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <AGFunc ref={AGRef} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                entrycallback={MenuAction}
                usecondition={true}
                entryform={true}
                primarykey={primarykeys}
                show={Show}
           >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.5,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
